var React = require('react');

function Lightning (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#73004C","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"2","d":"M15 18H8l6-16h7l-4 10h7l-9 18V18Z"}));
}

Lightning.defaultProps = {"width":"32","height":"32","fill":"none","viewBox":"0 0 32 32"};

module.exports = Lightning;

Lightning.default = Lightning;
